import { useState, useEffect } from "react";
import http from "../services/httpService";

export function useApi({ url, type = "get", data = {}, headers = {}, callback = [] }) {
  const [json, setJson] = useState({});

  useEffect(() => {
    (async function () {
      const response = await http[type](url, data, { headers });
      response?.status === 200 && setJson(response?.data);
    })();
  }, [url]);

  return json;
}
